var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 0.291014C17.9079 0.0481786 17.0921 0.0481773 16.3333 0.291012L4.8489 3.96601C3.26338 4.47338 2.1875 5.94727 2.1875 7.612V15.3121C2.1875 18.7378 2.88582 22.2737 5.03825 25.5543C7.1888 28.8323 10.6933 31.7069 16.0455 33.9865C16.973 34.3815 18.027 34.3815 18.9545 33.9865C24.3066 31.7069 27.8112 28.8323 29.9618 25.5543C32.1143 22.2737 32.8125 18.7378 32.8125 15.3121V7.612C32.8125 5.94727 31.7367 4.47338 30.1512 3.96601L18.6667 0.291014ZM17.3333 3.41616C17.4417 3.38146 17.5583 3.38146 17.6667 3.41616L29.1511 7.09116C29.3775 7.16363 29.5312 7.3742 29.5312 7.612V15.3121C29.5312 18.2835 28.9303 21.1447 27.2182 23.7544C25.5043 26.367 22.5785 28.8765 17.6687 30.9677C17.5627 31.0128 17.4373 31.0128 17.3313 30.9677C12.4215 28.8765 9.49581 26.367 7.78175 23.7544C6.06955 21.1447 5.46875 18.2835 5.46875 15.3121V7.612C5.46875 7.3742 5.62244 7.16363 5.84896 7.09116L17.3333 3.41616ZM24.6757 13.7379C25.3164 13.0972 25.3164 12.0584 24.6757 11.4177C24.0349 10.777 22.9963 10.777 22.3556 11.4177L15.8594 17.9139L13.7382 15.7927C13.0975 15.152 12.0587 15.152 11.418 15.7927C10.7773 16.4334 10.7773 17.4722 11.418 18.1129L14.6993 21.3941C15.34 22.0348 16.3788 22.0348 17.0195 21.3941L24.6757 13.7379Z",
    fill: "#57B182"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIconGreen);
export default __webpack_public_path__ + "static/media/shieldIconGreen.1cf3bc89d5bc2367cb81f362a3ce1070.svg";
export { ForwardRef as ReactComponent };